import type { PassInstanceStatus, PassProviderInstanceSummary } from '../models/Pass';

type PassPurchaseActionRow = Pick<
  PassProviderInstanceSummary,
  'status' | 'passPurchaseId' | 'paymentCollectedAt'
>;

/** Host sold-pass row for a cash purchase that is not activated yet (synthetic list row). */
export function isPendingCashPassPurchase(instance: PassPurchaseActionRow): boolean {
  return (
    instance.status === 'PENDING_PAYMENT' &&
    Boolean(instance.passPurchaseId?.trim()) &&
    !instance.paymentCollectedAt
  );
}

/**
 * Activate issues the pass and marks cash payment collected.
 * Online purchases activate automatically on Stripe settlement.
 * Also allows settling legacy activated-but-unpaid cash rows.
 */
export function canActivatePassPurchase(instance: PassPurchaseActionRow): boolean {
  if (!instance.passPurchaseId?.trim() || instance.paymentCollectedAt) {
    return false;
  }
  return instance.status === 'PENDING_PAYMENT' || instance.status === 'ACTIVE';
}

export function isActiveSoldPassTabStatus(status: PassInstanceStatus): boolean {
  return status === 'ACTIVE' || status === 'PENDING_PAYMENT';
}
